import { useState } from "react";
import { useSelector } from "react-redux";
import { mapEdgesToNodes } from "../../../../base/utils";
import { useCategoriesQuery } from "../../../../saleor/api";
import { CategoryTransformer } from "../../../../services/objectTransformer/categories";
import { Note } from "../../../../helbest";
import { useTranslation } from "react-i18next";

const useCategory = () => {
  const [categories, setCategories] = useState([]);
  const { Login: loginData } = useSelector((state) => state);
  const { i18n } = useTranslation();

  const { refetch, loading } = useCategoriesQuery({
    variables: {
      first: 10,
      level: 0,
      channel: loginData.channel,
      productFilter: {
        attributes: [{ slug: "state", values: [loginData.state_slug] }],
      },
      lng: i18n.language.toUpperCase(),
    },
    onCompleted: (response) => {
      setCategories(
        mapEdgesToNodes(response.categories.edges, (category) =>
          CategoryTransformer(category, 0),
        ),
      );
    },
    skip: categories.length,
    onError: (error) => {
      Note.error(error.message);
    },
  });

  return {
    categories,
    fetchCategories: refetch,
    loading,
  };
};

export default useCategory;
